import { render } from "./ProductCategorySelectorHeader.vue?vue&type=template&id=447a1ae3&ts=true"
import script from "./ProductCategorySelectorHeader.vue?vue&type=script&lang=ts"
export * from "./ProductCategorySelectorHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/product-category-selector/product-category-selector-header/ProductCategorySelectorHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "447a1ae3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('447a1ae3', __exports__)) {
    api.reload('447a1ae3', __exports__)
  }
  
  module.hot.accept("./ProductCategorySelectorHeader.vue?vue&type=template&id=447a1ae3&ts=true", () => {
    api.rerender('447a1ae3', render)
  })

}


export default __exports__